'use client';

// Post lifecycle chip. Colors come from theme tokens (--ok / --status-away /
// --err / surfaces) so it flips Booth ⇄ Daylight with no per-theme branch.
export type WorkshopStatus = 'live' | 'in_review' | 'draft' | 'rejected';

const MAP: Record<
  WorkshopStatus,
  { label: string; color: string; soft: string; dot?: boolean }
> = {
  live: {
    label: 'Live',
    color: 'var(--ok)',
    soft: 'color-mix(in oklab, var(--ok) 15%, transparent)',
    dot: true,
  },
  in_review: {
    label: 'In review',
    color: 'var(--status-away)',
    soft: 'color-mix(in oklab, var(--status-away) 15%, transparent)',
  },
  draft: { label: 'Draft', color: 'var(--text-tertiary)', soft: 'var(--surface-3)' },
  rejected: {
    label: 'Rejected',
    color: 'var(--err)',
    soft: 'color-mix(in oklab, var(--err) 14%, transparent)',
  },
};

export default function StatusChip({ status }: { status: string }) {
  const s = MAP[(status as WorkshopStatus)] || MAP.draft;
  return (
    <span
      className="inline-flex items-center gap-1.5 h-[22px] px-2.5 rounded-full text-[11px] font-semibold"
      style={{ background: s.soft, color: s.color }}
    >
      {s.dot && <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.color }} />}
      {s.label}
    </span>
  );
}

// clicks ÷ views, guarded; "—" when there are no views yet.
export function ctr(clicks: number, views: number): string {
  if (!views) return '—';
  return `${((clicks / views) * 100).toFixed(1)}%`;
}
